import React from 'react';

import OutputText from '@ey/canvascoreservices/OutputText';

export const prop = 'roleType';

const RoleTypeColumn = ({roleType, labels}) => {
	const txt = labels?.gaRoleType?.find(({id}) => id === roleType)?.label;
	const props = {
		children: txt,
		title: txt
	};

	return <OutputText body2 light {...props} ellipsis />;
};

export const config = (labels) => ({
	id: 'roleTypeColumn',
	label: labels.type,
	propName: prop,
	width: '15%',
	sortBy: prop,
	customCell: (item) => <RoleTypeColumn {...item} labels={labels} />
});
